module.exports = __webpack_public_path__ + "static/media/bluehead.627f29bb.png";